import { Platform } from '@cart-services/hooks/fp-b2b/store-map'
import { useFpB2bProductCatalogProducts } from '@cart-services/hooks/fp-b2b/use-fp-b2b-product-catalog-products'
import { type CrossBrandMallHomeCampaign } from '@hooks-api/types/dataModel/cross-brand-mall'
import { useMemo } from 'react'
import { type ProductCardEntry } from '../types/product-card-entry'
import { getNewArrivalProductCards } from '../utils/brand-new-arrival-transformer'

interface UseBrandNewArrivalProductsProps {
  campaign: CrossBrandMallHomeCampaign
}

interface UseBrandNewArrivalProductsResult {
  productCardEntries: ProductCardEntry[]
  isProductsLoading: boolean
}

export const useBrandNewArrivalProducts = (
  props: UseBrandNewArrivalProductsProps,
): UseBrandNewArrivalProductsResult => {
  const { campaign } = props

  const { productCatalogDto, isValidating: isCatalogValidating, error: catalogError } = useFpB2bProductCatalogProducts(
    campaign.campaign_id,
    campaign.project_code,
    campaign.code,
    Platform.STM,
  )

  const productCardEntries = useMemo<ProductCardEntry[]>(
    () => getNewArrivalProductCards(productCatalogDto),
    [productCatalogDto],
  )

  return {
    productCardEntries,
    isProductsLoading: !catalogError && (isCatalogValidating || !productCatalogDto),
  }
}
